export const ANALYTICS_ID = 'G-34DZ927854'
export const isAnalyticsEnabled = () => process.env.GATSBY_NOINDEX !== 'true' && process.env.GATSBY_IS_PREVIEW !== 'true'

// Preserve the existing ReactGA event contract using the already loaded tag.
// Consent defaults and updates are still owned by the existing consent flow.
export const trackAnalyticsEvent = ({ action, category, label, nonInteraction, ...parameters }) => {
    if (typeof window === 'undefined' || !isAnalyticsEnabled()) return
    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        non_interaction: nonInteraction,
        ...parameters
    })
}

export const updateAnalyticsConsent = allowed => {
    if (typeof window === 'undefined' || !isAnalyticsEnabled()) return
    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
    window.gtag('consent', 'update', {
        ad_storage: allowed ? 'granted' : 'denied',
        ad_user_data: allowed ? 'granted' : 'denied',
        ad_personalization: allowed ? 'granted' : 'denied',
        analytics_storage: allowed ? 'granted' : 'denied'
    })
}
